import { createFileRoute } from "@tanstack/react-router";
import { buildRouteHead } from "@/lib/seo/routeHead";
import ThankYou from "@/pages/ThankYou";
const ThankYouRoute = () => <ThankYou variant="download" />;

export const Route = createFileRoute("/es/gracias/descarga")({
  head: () => buildRouteHead("/es/gracias/descarga"),
  component: ThankYouRoute,
});

